import { Component } from 'react';
import PropTypes from 'prop-types';
import { getCurrentHub, BrowserClient, defaultIntegrations } from '@sentry/browser';
import { connect } from 'react-redux';
import { getErrors } from '../../redux/selectors/errors';
import getUserMessages from './getUserMessages';
import BrowserCompatibility from '../../helpers/BrowserCompatibility/BrowserCompatibility';
import getValueFromWindow from '../../helpers/getValueFromWindow';
import packageJson from '../../../../package.json';


const mapStateToProps = state => ({
  errors: getErrors(state),
});

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.SENTRY_DSN = 'https://05573f45a7364b998eaeb96ea9b8a750@sentry.io/1481568';
    this.instanceType = getValueFromWindow('site_globals', 'instanceType');
    this.siteId = getValueFromWindow('site_globals', 'siteId');
    this.userAgent = navigator.userAgent;
    this.browserBaseline = ['Safari 10', 'Chrome 56', 'Edge 15', 'Firefox 51'];

    this.setupSentry();
  }

  componentWillReceiveProps(nextProps) {
    const { errors } = this.props;

    if (nextProps.errors !== errors && nextProps.errors.length) {
      this.reportToUser(nextProps.errors);
    }
  }

  setupSentry() {
    if (/production/.test(this.instanceType)) {
      this.sentry = getCurrentHub();

      this.sentry.bindClient(
        new BrowserClient({
          debug: true,
          dsn: this.SENTRY_DSN,
          release: packageJson.version,
          integrations: defaultIntegrations,
          beforeSend(event) {
            if (event.extra && event.extra.componentId) {
              return event;
            }

            return null;
          },
        }),
      );
    }
  }

  reportToUser(errors) {
    const { blockUserOnError } = this.props;

    if (blockUserOnError) {
      window.emitMarketplaceEvent(
        'showUserErrorMessage',
        getUserMessages(errors),
      );
    }
  }

  componentDidCatch(error, errorInfo) {
    this.reportToUser(error);
    this.reportToSentry(error, errorInfo);
  }

  isSupportedBrowser() {
    const browserChecker = new BrowserCompatibility(this.userAgent, this.browserBaseline);

    return browserChecker.isBrowserSupported;
  }

  reportToSentry(error, errorInfo = {}) {
    const { componentId, blockUserOnError } = this.props;

    if (this.sentry && this.isSupportedBrowser()) {
      this.sentry.withScope((scope) => {
        scope.setExtras({
          componentId,
          instanceType: this.instanceType,
          siteId: this.siteId,
          url: location.href,
          userAgent: this.userAgent,
          blockUserOnError,
        });
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key]);
        });
        this.sentry.captureException(error);
      });
    }
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

Boundary.propTypes = {
  componentId: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({})),
  blockUserOnError: PropTypes.bool.isRequired,
};

Boundary.defaultProps = {
  errors: undefined,
};

export default {
  withStore: connect(mapStateToProps)(Boundary),
  withoutStore: Boundary,
};
